export const PAGE_SIZE = 10;
export const MAX_FEED_PAGES_TO_LOAD = 2;
export const MAIN_COLOR = "#e22e18";
export const MAX_TITLE_LENGTH = 45;
export const MAX_MESSAGE_LENGTH = 600;
